/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AccountManagerUpdateResponse } from './AccountManagerUpdateResponse';

export type AccountManagerUpdateResponseApiRespoonse = {
    data?: AccountManagerUpdateResponse;
    status?: AccountManagerUpdateResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace AccountManagerUpdateResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

